import React from "react";
import { HelpCircle, Trash2, Plus } from "lucide-react";

/** Fully admin-editable FAQ list — add/remove/edit questions & answers. */
export default function FaqListEditor({ items, onChange }) {
  const arr = Array.isArray(items) ? items : [];
  const setAt = (i, patch) => onChange(arr.map((x, idx) => (idx === i ? { ...x, ...patch } : x)));
  const remove = (i) => onChange(arr.filter((_, idx) => idx !== i));
  const add = () => onChange([...arr, { q: "", a: "" }]);

  return (
    <div className="rounded-2xl bg-apex-card border border-apex-line p-5" data-testid="section-faq-list">
      <div className="text-xs uppercase tracking-[0.3em] text-apex-gold/80 mb-1 flex items-center gap-2">
        <HelpCircle className="w-3.5 h-3.5" /> Časté dotazy (FAQ)
      </div>
      <p className="text-xs text-apex-cream/60 mb-4">
        Přidávejte, upravujte nebo mažte otázky a odpovědi zobrazené v sekci „Časté dotazy“.
      </p>
      <div className="space-y-3">
        {arr.length === 0 && (
          <div className="text-xs italic text-apex-cream/45 px-2 py-1.5">
            Žádné otázky — přidejte první kliknutím na &bdquo;+ Přidat otázku&ldquo;.
          </div>
        )}
        {arr.map((item, i) => (
          <div key={i} className="rounded-xl border border-apex-line bg-apex-bg/50 p-4 space-y-2">
            <div className="flex items-start gap-2">
              <input
                type="text"
                value={item.q}
                onChange={(e) => setAt(i, { q: e.target.value })}
                placeholder="Otázka"
                className="flex-1 px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm font-semibold focus:outline-none focus:border-apex-gold/60"
                data-testid={`faq-item-${i}-q`}
              />
              <button
                type="button"
                onClick={() => remove(i)}
                className="px-2 py-2 rounded-lg border border-red-500/40 text-red-300 text-xs hover:bg-red-500/10"
                data-testid={`faq-item-${i}-remove`}
                title="Smazat otázku"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
            <textarea
              value={item.a}
              rows={2}
              onChange={(e) => setAt(i, { a: e.target.value })}
              placeholder="Odpověď"
              className="w-full px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm resize-y focus:outline-none focus:border-apex-gold/60"
              data-testid={`faq-item-${i}-a`}
            />
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={add}
        className="mt-3 text-xs px-3 py-1.5 rounded-lg border border-apex-gold/40 text-apex-gold hover:bg-apex-gold/10 inline-flex items-center gap-1.5"
        data-testid="faq-item-add"
      >
        <Plus className="w-3.5 h-3.5" /> Přidat otázku
      </button>
    </div>
  );
}
